import React from 'react';
import PropTypes from 'prop-types';

export default function StructureToolbarCustomerIconTooltip({ customerLabel }) {
  return (
    <>
      <div>
        Building Block from: <b>{customerLabel}</b>
      </div>
      <div>click to copy SMILES</div>
    </>
  );
}

StructureToolbarCustomerIconTooltip.propTypes = {
  customerLabel: PropTypes.string,
};
